import React from 'react';
import CountryService from '../services/country';
import UserService from '../services/user';
import Modal from 'react-bootstrap/Modal';
import $ from 'jquery';
import AuthorizationCheck from '../auth/authorizationCheck';
import Utility from '../utilities/utility';
import BranchService from '../services/branch';
import UserRestrictionModal from './UserRestrictionModal';

class CreateUser extends React.Component {

    constructor(props) {
        super(props);

        this.countryService = new CountryService();
        this.userService = new UserService();
        this.branchService = new BranchService();
        this.searchTimeout = null;

        this.state = {
            countries: [],
            closeModal: false,
            showModal: false,
            users: [],
            currentUserRole: '',
            groups: [],
            branches: [],

            searchTerm: '',
            searchCountryId: '',
            searching: false,

            restrictions: [],
            userRestrictions: [],
            selectedUser: null,
            showRestrictionModal: false
        };
    }

    componentDidMount() {
        this.fetchCountries();
        this.fetchUsers();
        this.fetGroups();
        this.fetchRestrictions();
    }

    componentWillUnmount() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }

    fetchCountries = async () => {
        try {
            const response = await this.countryService.fetchCountries();
            this.setState({ countries: await response.json() });
        } catch (error) {
            console.log(error);
        }
    }

    fetGroups = async () => {
        try {
            const response = await this.userService.groups();
            this.setState({ groups: await response.json() });
        } catch (error) {
            console.log(error);
        }
    }

    fetchRestrictions = async () => {
        try {
            const response = await this.userService.restrictions();
            this.setState({ restrictions: await response.json() });
        } catch (error) {
            console.log(error);
        }
    }

    showNewUserForm = () => {
        this.setState({ showModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showModal: false });
    }

    handleSearchTermChange = (e) => {
        const searchTerm = e.target.value;

        this.setState({ searchTerm });

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
            this.fetchUsers(searchTerm, this.state.searchCountryId);
        }, 700);
    }

    handleSearchCountryChange = (e) => {
        const searchCountryId = e.target.value;

        this.setState({ searchCountryId });

        this.fetchUsers(this.state.searchTerm, searchCountryId);
    }

    clearSearch = () => {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.setState({
            searchTerm: '',
            searchCountryId: ''
        });

        this.fetchUsers('', '');
    }

    createUser = () => {
        let name = $('#name').val();
        let address = $('#address').val();
        let username = $('#username').val();
        let password = $('#password').val();
        let countryId = $('#countryId').val();
        let groupId = $('#groupId').val();
        let branchId = $('#branchId').val();

        try {
            if (
                Utility.isEmpty(name) ||
                Utility.isEmpty(address) ||
                Utility.isEmpty(username) ||
                Utility.isEmpty(password) ||
                Utility.isEmpty(countryId) ||
                Utility.isEmpty(groupId) ||
                Utility.isEmpty(branchId)
            ) {
                $('.messageHolder').html(
                    '<div class="alert alert-danger user-alert">Entrer les champs obligatoires</div>'
                );

                $('.user-alert').delay(3000).fadeOut('slow');
                return;
            }

            const response = this.userService.createUser(
                name,
                address,
                username,
                password,
                countryId,
                groupId,
                branchId
            );

            response.then(res => res.ok ? res.json() : null)
                .then(user => {
                    if (user == null) {
                        $('.messageHolder').html(
                            '<div class="alert alert-danger user-alert">Probleme lors du creation de l utilisateur</div>'
                        );

                        $('.user-alert').delay(3000).fadeOut('slow');
                        return;
                    }

                    let users = [...this.state.users];
                    users.unshift(user);

                    this.setState({
                        users: users
                    });

                    $('.messageHolder').html(
                        '<div class="alert alert-success user-alert">Utilisateur crée</div>'
                    );

                    $('.user-alert').delay(3000).fadeOut('slow');

                }).catch(error => {
                    console.log(error);

                    $('.messageHolder').html(
                        '<div class="alert alert-danger user-alert">Probleme lors du creation de l utilisateur</div>'
                    );

                    $('.user-alert').delay(3000).fadeOut('slow');
                });

        } catch (error) {
            console.log(error);

            $('.messageHolder').html(
                '<div class="alert alert-danger user-alert">Probleme lors du creation de l utilisateur</div>'
            );

            $('.user-alert').delay(3000).fadeOut('slow');
        }
    }

    fetchUsers = async (
        searchTerm = this.state.searchTerm,
        countryId = this.state.searchCountryId
    ) => {
        try {
            this.setState({
                searching: true
            });

            const response = await this.userService.userList(searchTerm, countryId);

            this.setState({
                users: await response.json(),
                searching: false
            });

        } catch (error) {
            console.log(error);

            this.setState({
                searching: false
            });
        }
    }

    setRole = (role) => {
        this.setState({
            currentUserRole: role
        });
    }

    branchList = async () => {
        try {
            let countryId = $('#countryId').val();

            if (Utility.isEmpty(countryId)) {
                Utility.showAlertWithId(
                    'errorHolder',
                    'Veillez choisir le pays',
                    'danger',
                    true
                );

                return;
            }

            let name = $('#searchName').val();

            const response = await this.branchService.branchList(countryId, name);

            this.setState({
                branches: await response.json()
            });

        } catch (error) {
            console.log(error);
        }
    }

    updateUserRestricted = async (user, restricted) => {
        try {
            const response = await this.userService.updateUserRestricted(
                user.userId,
                restricted
            );

            if (!response.ok) {
                Utility.showAlertWithId(
                    'errorHolder',
                    'Impossible de modifier le status restriction',
                    'danger',
                    true
                );
                return;
            }

            let users = [...this.state.users];

            users = users.map(item => {
                if (item.userId === user.userId) {
                    return {
                        ...item,
                        restricted: restricted
                    };
                }

                return item;
            });

            this.setState({
                users: users
            });

        } catch (error) {
            console.log(error);

            Utility.showAlertWithId(
                'errorHolder',
                'Impossible de modifier le status restriction',
                'danger',
                true
            );
        }
    }

    openRestrictionModal = async (user) => {
        try {
            const response = await this.userService.userRestrictions(user.userId);

            this.setState({
                selectedUser: user,
                userRestrictions: await response.json(),
                showRestrictionModal: true
            });

        } catch (error) {
            console.log(error);
        }
    }

    closeRestrictionModal = () => {
        this.setState({
            selectedUser: null,
            userRestrictions: [],
            showRestrictionModal: false
        });
    }

    addRestrictionToUser = async (restrictionId) => {
        try {
            await this.userService.assignRestriction(
                this.state.selectedUser.userId,
                restrictionId
            );

            const response = await this.userService.userRestrictions(
                this.state.selectedUser.userId
            );

            this.setState({
                userRestrictions: await response.json()
            });

        } catch (error) {
            console.log(error);

            Utility.showAlertWithId(
                'restrictionMessageHolder',
                'Impossible d ajouter la restriction',
                'danger',
                true
            );
        }
    }

    removeRestrictionFromUser = async (userRestrictionId) => {
        try {
            await this.userService.removeUserRestriction(userRestrictionId);

            const response = await this.userService.userRestrictions(
                this.state.selectedUser.userId
            );

            this.setState({
                userRestrictions: await response.json()
            });

        } catch (error) {
            console.log(error);

            Utility.showAlertWithId(
                'restrictionMessageHolder',
                'Impossible de retirer la restriction',
                'danger',
                true
            );
        }
    }

    render() {
        const users = this.state.users;
        const branches = this.state.branches;

        let groupMap = [];
        groupMap['BRANCH'] = 'BRANCHE';
        groupMap['CUSTOMER'] = 'CLIENT';

        return (
            <div className="container users-wrapper">

                <AuthorizationCheck
                    accessLevel="MANAGER"
                    userRole={this.setRole}
                />

                

                <div id="errorHolder"></div>

                <UserRestrictionModal
                    show={this.state.showRestrictionModal}
                    onClose={this.closeRestrictionModal}
                    selectedUser={this.state.selectedUser}
                    restrictions={this.state.restrictions}
                    userRestrictions={this.state.userRestrictions}
                    onAdd={this.addRestrictionToUser}
                    onRemove={this.removeRestrictionFromUser}
                />

                <h2 className="mb-3 text-center">Creer Utilisateur</h2>

                <button
                        className="btn btn-primary new-user-btn"
                        onClick={this.showNewUserForm}
                    >
                        Nouveau
                    </button>

                <div className="card shadow-sm mb-4 mt-2">
                    <div className="card-header bg-light">
                        <strong>Recherche Utilisateur</strong>
                    </div>

                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Rechercher par nom, username ou adresse..."
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearchTermChange}
                                />
                            </div>

                            <div className="col-md-4 mb-2">
                                <select
                                    className="form-control"
                                    value={this.state.searchCountryId}
                                    onChange={this.handleSearchCountryChange}
                                >
                                    <option value="">Tous les pays</option>

                                    {this.state.countries.length > 0 &&
                                        this.state.countries.map(country =>
                                            <option
                                                key={country.countryId}
                                                value={country.countryId}
                                            >
                                                {country.name}
                                            </option>
                                        )
                                    }
                                </select>
                            </div>

                            <div className="col-md-2 mb-2">
                                <button
                                    className="btn btn-secondary full-width"
                                    onClick={this.clearSearch}
                                >
                                    Effacer
                                </button>
                            </div>
                        </div>

                        {this.state.searching &&
                            <div className="text-primary mt-2">
                                Recherche en cours...
                            </div>
                        }
                    </div>
                </div>

                <div className="create-user-wrapper">

                    

                    <Modal show={this.state.showModal} size="lg">
                        <Modal.Header closeButton onHide={this.handleCloseModal}>
                            Nouveau Utilisateur
                        </Modal.Header>

                        <Modal.Body>
                            <div className="form-wrapper">

                                <div className="messageHolder"></div>

                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        id="name"
                                        placeholder="Nom"
                                    />
                                </div>

                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        id="address"
                                        placeholder="Address"
                                    />
                                </div>

                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        id="username"
                                        placeholder="Username"
                                    />
                                </div>

                                <div className="form-group">
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        placeholder="Mot de Pass"
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="label">Pays</label>

                                    <select
                                        className="form-control full-width"
                                        id="countryId"
                                        onChange={this.branchList}
                                    >
                                        <option></option>

                                        {this.state.countries.length > 0 &&
                                            this.state.countries.map(country =>
                                                <option
                                                    key={country.countryId}
                                                    value={country.countryId}
                                                >
                                                    {country.name}
                                                </option>
                                            )
                                        }
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="label">Group</label>

                                    <select
                                        className="form-control full-width"
                                        id="groupId"
                                    >
                                        <option></option>

                                        {this.state.groups.length > 0 &&
                                            this.state.groups.map(group => {
                                                let groupName = '';

                                                if (group.name === 'BRANCH') {
                                                    groupName = 'BRANCHE';
                                                } else if (group.name === 'CUSTOMER') {
                                                    groupName = 'CLIENT';
                                                }

                                                return (
                                                    <option
                                                        key={group.groupId}
                                                        value={group.groupId}
                                                    >
                                                        {groupName}
                                                    </option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="label">Branches</label>

                                    <select
                                        className="form-control"
                                        id="branchId"
                                    >
                                        <option></option>

                                        {branches.length > 0 &&
                                            branches.map(branch =>
                                                <option
                                                    key={branch.branchId}
                                                    value={branch.branchId}
                                                >
                                                    {branch.name}
                                                </option>
                                            )
                                        }
                                    </select>
                                </div>

                                <div className="button-wrapper">
                                    <button
                                        className="btn btn-primary full-width"
                                        onClick={this.createUser}
                                    >
                                        Creer
                                    </button>
                                </div>

                            </div>
                        </Modal.Body>

                        <Modal.Footer></Modal.Footer>
                    </Modal>

                    

                </div>

                <div className="user-list mt-4">

                    {users.length > 0 && users.map(user =>
                        <div
                            className="card card-default mt-4"
                            key={user.userId}
                        >

                            <div className="card-header bg-info">
                                <div className="row">
                                    <div className="col">Nom</div>
                                    <div className="col">Username</div>
                                    <div className="col">Address</div>
                                    <div className="col">Role</div>
                                    <div className="col">Pays</div>
                                    <div className="col">Restriction</div>
                                    <div className="col">Actions</div>
                                </div>
                            </div>

                            <div className="card-body">
                                <div className="row">
                                    <div className="col">
                                        <div>{user.name}</div>

                                        <div className="text-primary mt-2">
                                            {user.group && groupMap[user.group.name]}
                                        </div>
                                    </div>

                                    <div className="col">
                                        {user.username}
                                    </div>

                                    <div className="col">
                                        {user.address}
                                    </div>

                                    <div className="col">
                                        {user.role && user.role.name}
                                    </div>

                                    <div className="col">
                                        {user.country && user.country.name}
                                    </div>

                                    <div className="col">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={Boolean(user.restricted)}
                                                onChange={(e) =>
                                                    this.updateUserRestricted(user, e.target.checked)
                                                }
                                            />

                                            <label className="form-check-label text-danger fw-bold">
                                                Restricted
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <a
                                            className="btn btn-sm btn-info mr-2"
                                            href={
                                                "/admin/user/update?userId=" +
                                                user.userId +
                                                "&countryId=" +
                                                user.country.countryId
                                            }
                                        >
                                            Edit
                                        </a>

                                        <button
                                            className="btn btn-sm btn-warning mt-2"
                                            onClick={() => this.openRestrictionModal(user)}
                                        >
                                            Restrictions
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    )}

                    {users.length === 0 &&
                        <div className="alert alert-info mt-4">
                            Aucun utilisateur trouvé
                        </div>
                    }

                </div>

            </div>
        );
    }
}

export default CreateUser;